export enum InterviewCloseEnum {
    Interview = 'interview',
    SignOut = 'signOut',
    ApplicantTerminate = 'applicantTerminate'
}
